import Controller from "@ember/controller"
import { inject as service } from "@ember/service"

export default class ReferralsController extends Controller {
  @service modalManager

  showModal = (userId) => {
    this.modalManager.openModal("user/dub-referrals", {
      userId: userId,
    })
  }
}
